import {Component, OnInit} from '@angular/core';
import {AppComponent} from "../app.component";
import {EventoComponent} from "../evento/evento.component";
import {Evento} from "../eventos/evento";
import {MAX_TAM_ARQ} from './../constante';
declare var jQuery:any;

@Component({
    selector: 'app-evento-detail',
    templateUrl: '../evento/evento.component.html',
    styleUrls: ['./evento-detail.component.css']
})
export class EventoDetailComponent extends EventoComponent implements OnInit {

    id:number;
    evento:any;

    ngOnInit() {
		if (!this.isAdmin())
            this.router.navigateByUrl('inicio');
		else {
			this.route.params.subscribe(params => this.id = +params['id']);
			this.eventoService.get_id(this.id)
				.then((evento)=>this.setevento(evento));
		}
    }

    setevento(evento){
		
        this.evento=evento;
        this.evento.datalimitsub = this.evento.datalimit = this.datePipe.transform(this.evento.datalimit, 'yyyy-MM-ddTHH:mm');
		this.evento.datainicio = this.datePipe.transform(this.evento.datainicio, 'yyyy-MM-ddTHH:mm');
        // jQuery("#datalimit").val(this.evento.datalimit);
        // console.log(this.evento);

    }

    onSubmit() {
		if (new Date(this.evento.datainicio) >= new Date(this.evento.datalimit)) {
			this.utils.exibirMensagem('A data de início deve ser anterior à data limite.', 'warning');
			return null;
		}
		
		this.evento.datalimitsub = this.evento.datalimit;
		
		if (this.evento.imagem && this.evento.imagem.size > MAX_TAM_ARQ) {
			this.utils.exibirMensagem('O tamanho do arquivo têm que ser menor do que 10 Mb.', 'danger');
			return null;
		} 
		this.spinnerService.show();
        this.eventoService.update(this.evento)
            .then(() => this.goBack());
    }


}



// WEBPACK FOOTER //
// ./src/app/evento-detail/evento-detail.component.ts